// Vaanmathi
import React, { useState } from "react";
import "./Registration.css";
import axios from "axios";
import { showMyAlert } from "../../Utils/alertService";
import { useNavigate, useLocation } from "react-router-dom";

const RegisterPage = () => {

  // Delli
  const navigate = useNavigate();
  const location = useLocation();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    mobileNumber: "",
    password: "",
    confirmPassword: "",
    role: "superadmin",
    status: "active",
  });

  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (
      !formData.fullName ||
      !formData.email ||
      !formData.mobileNumber ||
      !formData.password ||
      !formData.confirmPassword
    ) {
      showMyAlert({
        type: "danger", // "success" | "danger" | "warning" | "info"
        title: "Error",
        message: "Please fill in all required fields.",
        duration: 3000,
      });
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      showMyAlert({
        type: "danger", // "success" | "danger" | "warning" | "info"
        title: "Error",
        message: "Passwords do not match.",
        duration: 3000,
      });
      return;
    }

    const passwordValidation = validatePassword(formData.password);
    if (!passwordValidation.isValid) {
      let errorMessage = "Password must contain:";
      if (formData.password.length < passwordValidation.minLength)
        errorMessage += ` at least ${passwordValidation.minLength} characters,`;
      if (!passwordValidation.hasUpperCase)
        errorMessage += " one uppercase letter,";
      if (!passwordValidation.hasLowerCase)
        errorMessage += " one lowercase letter,";
      if (!passwordValidation.hasNumber) errorMessage += " one number,";
      if (!passwordValidation.hasSpecialChar)
        errorMessage += " one special character,";

      errorMessage = errorMessage.replace(/,$/, ".");
      showMyAlert({
        type: "danger", // "success" | "danger" | "warning" | "info"
        title: "Error",
        message: errorMessage,
        duration: 3000,
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      showMyAlert({
        type: "danger", // "success" | "danger" | "warning" | "info"
        title: "Error",
        message: "Please enter a valid email address.",
        duration: 3000,
      });
      return;
    }

    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(formData.mobileNumber)) {
      showMyAlert({
        type: "danger", // "success" | "danger" | "warning" | "info"
        title: "Error",
        message: "Please enter a valid 10-digit mobile number.",
        duration: 3000,
      });
      return;
    }

    setLoading(true);

    // Get current date and time
    const now = new Date();
    const createdDate = now.toISOString().slice(0, 10);
    const createdTime = now.toTimeString().slice(0, 8);

    const getISTDateTime = () => {
      const now = new Date();
      const istOffset = 5.5 * 60 * 60 * 1000;
      const istTime = new Date(now.getTime() + istOffset);

      const day = String(istTime.getUTCDate()).padStart(2, "0");
      const month = String(istTime.getUTCMonth() + 1).padStart(2, "0");
      const year = istTime.getUTCFullYear();

      const hours = String(istTime.getUTCHours()).padStart(2, "0");
      const minutes = String(istTime.getUTCMinutes()).padStart(2, "0");
      const seconds = String(istTime.getUTCSeconds()).padStart(2, "0");

      return {
        date: `${day}-${month}-${year}`,
        time: `${hours}:${minutes}:${seconds}`,
      };
    };

    const { date, time } = getISTDateTime();

    try {
      const mobileRes = await axios.get(
        `https://api.dremerz.net/api/DZ_8922_Payroll_PayrollCreateAdmin_PayrollAdminList?mobileNumber=${formData.mobileNumber}`
      );
      const emailRes = await axios.get(
        `https://api.dremerz.net/api/DZ_8922_Payroll_PayrollCreateAdmin_PayrollAdminList?email=${formData.email}`
      );
      const res = await axios.get(
        "https://api.dremerz.net/api/DZ_8922_Payroll_PayrollCreateAdmin_PayrollAdminList"
      );

      const admins = res.data;
      const lastData = admins[admins.length - 1];
      if (mobileRes.data && mobileRes.data.length > 0) {
        showMyAlert({
          type: "danger", // "success" | "danger" | "warning" | "info"
          title: "Error",
          message:
            "Mobile Numbner Already Registered, Try with a different one",
          duration: 3000,
        });
        return;
      }
      if (emailRes.data && emailRes.data.length > 0) {
        showMyAlert({
          type: "danger", // "success" | "danger" | "warning" | "info"
          title: "Error",
          message: "Email Already Registered, Try with a different one",
          duration: 3000,
        });
        return;
      }
      const response = await fetch(
        "https://api.dremerz.net/api/DZ_8922_Payroll_PayrollCreateAdmin_PayrollAdminList",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userName: null,
            fullName: formData.fullName,
            email: formData.email,
            mobileNumber: formData.mobileNumber,
            password: formData.password,
            confirmPassword: formData.confirmPassword,
            role: formData.role,
            status: formData.status,
            createdDate,
            createdTime,
            accountStatus: "freeTrail",
            demoRegDate: date,
            demoRegTime: time,
            permissions:
              "dashboard,addlocation,usermng,empdetail,employeemanagement,empdetails,empdetailsunapproved,employees,addhours,setsalary,assignlocation,editlocation,leavemanagement,payslip-generate,paysliprecord,payslipdata,payrollconfigurator,revenue,userauthentication,adminmanagement,auditlogs",
            companyKey: `IDL000${lastData.id}`,
          }),
        }
      );

      const data = await response.json();
      if (response.ok) {
        if (
          data.success === true ||
          (data.message && data.message.toLowerCase().includes("success")) ||
          (data.status && data.status.toLowerCase().includes("success")) ||
          data.isSuccess === true ||
          (typeof data === "object" && Object.keys(data).length === 0)
        ) {
          const autoLoginData = {
            mobileNumber: formData.mobileNumber,
            password: formData.password,
            email: formData.email,
            fullName: formData.fullName
          };

          // Store in localStorage to pass to signIn page
          localStorage.setItem("autoLoginData", JSON.stringify(autoLoginData));
          localStorage.setItem("showAutoLoginAlert", "true");

          showMyAlert({
            type: "success",
            title: "Success",
            message: "Registration successful! Auto-logging you in...",
            duration: 2000,
          });

          // Redirect to signIn page with auto-login flag
          setTimeout(() => {
            navigate("/signIn", {
              state: {
                autoLogin: true,
                mobileNumber: formData.mobileNumber,
                password: formData.password
              }
            });
          }, 1500);
        }
      } else {
        // Handle HTTP errors
        showMyAlert({
          type: "danger", // "success" | "danger" | "warning" | "info"
          title: "Error",
          message: data.message || "Registration failed. Please try again.",
          duration: 3000,
        });
        console.error("Some Error Occured while fetching Data..");
        return;
      }
    } catch (err) {
      showMyAlert({
        type: "danger", // "success" | "danger" | "warning" | "info"
        title: "Error",
        message:
          "Network error. Please check your internet connection and try again.",
        duration: 5000,
      });
      console.error("Registration error:", err);
    } finally {
      setLoading(false);
    }
  };

  const validatePassword = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    return {
      isValid:
        password.length >= minLength &&
        hasUpperCase &&
        hasLowerCase &&
        hasNumber &&
        hasSpecialChar,
      minLength,
      hasUpperCase,
      hasLowerCase,
      hasNumber,
      hasSpecialChar,
    };
  };

  const handleSignInClick = () => {
    window.location.href = "/signIn";
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: "#f8f4f0" }}>
      <div className="container-fluid">
        <div className="min-vh-100 d-flex flex-wrap">
          {/* Left Side */}
          <div
            className="col-lg-6 d-flex flex-column position-relative order-2 order-md-1"
            style={{ borderRight: "1px solid #e0e0e0" }}
          >
            <div className="flex-grow-1 d-flex align-items-center justify-content-center px-4">
              {/* Background decorative elements */}
              <div
                className="position-absolute"
                style={{
                  top: "10%",
                  left: "10%",
                  width: "300px",
                  height: "200px",
                  background: "linear-gradient(135deg, #ff7b7b, #ff9a56)",
                  borderRadius: "50%",
                  opacity: "0.3",
                  filter: "blur(40px)",
                }}
              ></div>

              <div
                className="position-absolute"
                style={{
                  bottom: "20%",
                  right: "10%",
                  width: "200px",
                  height: "200px",
                  background: "linear-gradient(135deg, #4ecdc4, #44a08d)",
                  borderRadius: "50%",
                  opacity: "0.3",
                  filter: "blur(40px)",
                }}
              ></div>

              <div className="text-center">
                {/* Process Steps - Centered */}
                <div className="mb-5 position-relative d-flex align-items-center justify-content-center">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center mb-3">
                      <div
                        className="bg-success rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{ width: "24px", height: "24px" }}
                      >
                        <i
                          className="fas fa-check text-white"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </div>
                      <span className="text-dark fw-medium">
                        Create your account
                      </span>
                    </div>

                    <div className="d-flex align-items-center mb-3">
                      <div
                        className="bg-success rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{ width: "24px", height: "24px" }}
                      >
                        <i
                          className="fas fa-check text-white"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </div>
                      <span className="text-dark fw-medium">
                        Configure settings
                      </span>
                    </div>

                    <div className="d-flex align-items-center">
                      <div
                        className="bg-success rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{ width: "24px", height: "24px" }}
                      >
                        <i
                          className="fas fa-check text-white"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </div>
                      <span className="text-dark fw-medium">Run payroll</span>
                    </div>
                  </div>
                </div>

                {/* Main Heading */}
                <h1 className="display-5 fw-bold text-dark mb-5 position-relative">
                  Payroll made simple, efficient,
                  <br />
                  and auto-compliant for every
                  <br />
                  business.
                </h1>
              </div>
            </div>

            {/* Trusted By Section - Moved to bottom */}
            {/* <div className="pb-4 px-4 position-relative">
              <div className="text-center">
                <p className="text-muted mb-4">Trusted by companies</p>
                <div className="d-flex justify-content-center align-items-center flex-wrap gap-4">
                  <span className="text-muted fw-medium">Companyname</span>
                  <span className="text-muted fw-medium">Companyname</span>
                  <span className="text-muted fw-medium">Companyname</span>
                  <span className="text-muted fw-medium">Companyname</span>
                  <span className="text-muted fw-medium">Companyname</span>
                </div>
              </div>
            </div> */}
          </div>

          {/* Right Side - Registration Form */}
          <div
            className="col-lg-6 d-flex align-items-center justify-content-center position-relative order-1 order-md-2"
            style={{ backgroundColor: "#f8f4f0" }}
          >
            {/* Background decorative elements for right side */}
            <div
              className="position-absolute"
              style={{
                top: "15%",
                left: "15%",
                width: "250px",
                height: "180px",
                background: "linear-gradient(135deg, #ff7b7b, #ff9a56)",
                borderRadius: "50%",
                opacity: "0.2",
                filter: "blur(40px)",
              }}
            ></div>

            <div
              className="position-absolute"
              style={{
                bottom: "25%",
                right: "15%",
                width: "180px",
                height: "180px",
                background: "linear-gradient(135deg, #4ecdc4, #44a08d)",
                borderRadius: "50%",
                opacity: "0.2",
                filter: "blur(40px)",
              }}
            ></div>

            <div
              className="w-100 px-4 position-relative"
              style={{ maxWidth: "480px", zIndex: 1 }}
            >
              {/* Logo */}
              <div className="text-center mb-0">
                <div className="d-flex align-items-center justify-content-center mb-1">
                  <h4 className="fw-bold text-dark mt-4">PAYROLL</h4>
                </div>
              </div>

              <h2 className="text-dark text-center mb-4 fw-bold">Let's get started</h2>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* Full Name */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        placeholder="Full Name *"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleInputChange}
                        required
                        style={{
                          borderColor: "#e0e0e0",
                          fontSize: "16px",
                          padding: "12px 16px",
                        }}
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <input
                        type="email"
                        className="form-control form-control-lg"
                        placeholder="Email Address *"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        style={{
                          borderColor: "#e0e0e0",
                          fontSize: "16px",
                          padding: "12px 16px",
                        }}
                      />
                    </div>
                  </div>

                  {/* Mobile Number */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <div className="input-group">
                        <select
                          className="form-select"
                          style={{
                            maxWidth: "80px",
                            borderColor: "#e0e0e0",
                            fontSize: "16px",
                          }}
                        >
                          <option value="+91">+91</option>
                        </select>
                        <input
                          type="tel"
                          className="form-control form-control-lg"
                          placeholder="Mobile Number *"
                          name="mobileNumber"
                          value={formData.mobileNumber}
                          onChange={handleInputChange}
                          required
                          style={{
                            borderColor: "#e0e0e0",
                            fontSize: "16px",
                            padding: "12px 16px",
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Password */}
                  <div className="col-md-12">
                    <div className="mb-3 position-relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control form-control-lg"
                        placeholder="Password *"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        required
                        style={{
                          borderColor: "#e0e0e0",
                          fontSize: "16px",
                          padding: "12px 16px",
                          paddingRight: "40px",
                        }}
                      />
                      <span
                        onClick={() => setShowPassword((prev) => !prev)}
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#888",
                          fontSize: "20px",
                          zIndex: 2,
                        }}
                        aria-label={
                          showPassword ? "Hide password" : "Show password"
                        }
                      >
                        <i
                          className={`fa${showPassword ? "s" : "r"} fa-eye${showPassword ? "-slash" : ""
                            }`}
                        ></i>
                      </span>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="mb-3 position-relative">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control form-control-lg"
                        placeholder="Confirm Password *"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        required
                        style={{
                          borderColor: "#e0e0e0",
                          fontSize: "16px",
                          padding: "12px 16px",
                          paddingRight: "40px",
                        }}
                      />
                      <span
                        onClick={() => setShowConfirmPassword((prev) => !prev)}
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#888",
                          fontSize: "20px",
                          zIndex: 2,
                        }}
                        aria-label={
                          showConfirmPassword
                            ? "Hide password"
                            : "Show password"
                        }
                      >
                        <i
                          className={`fa${showConfirmPassword ? "s" : "r"
                            } fa-eye${showConfirmPassword ? "-slash" : ""}`}
                        ></i>
                      </span>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <button
                      type="submit"
                      className="btn btn-danger btn-lg w-100 mb-4"
                      disabled={loading}
                      style={{
                        backgroundColor: "#E7472C",
                        borderColor: "#ff4444",
                        fontSize: "16px",
                        padding: "12px",
                        fontWeight: "500",
                      }}
                    >
                      {loading ? "SIGNING UP..." : "SIGN UP NOW"}
                    </button>
                  </div>

                  {/* Sign In Link */}
                  <div className="col-md-12">
                    <p className="text-center text-muted small">
                      Already have an account?{" "}
                      <button
                        type="button"
                        className="bg-transparent border-0 p-0"
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                          color: "#ff4444",
                          fontWeight: "500",
                        }}
                        onClick={handleSignInClick}
                      >
                        Sign In
                      </button>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
      />

      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
        rel="stylesheet"
      />
    </div>
  );
};

export default RegisterPage;
